import { 
    AllInclusive, 
    Checkroom, 
    Flare, 
    Movie, 
    Spa, 
    Sports, 
    SportsBar, 
    TravelExplore,
    Restaurant,
    Palette,
    Computer,
    Business,
    School,
    MusicNote,
    Nature,
    SportsEsports,
    CameraAlt,
    VolunteerActivism,
    FitnessCenter,
    MenuBook,
    Favorite,
    DateRange,
    Work,
    BuildCircle
} from "@mui/icons-material";
import { 
    FormControl, 
    InputLabel, 
    MenuItem, 
    Select, 
    Box, 
    Typography 
} from "@mui/material";
import { styled } from "@mui/material/styles";

// Styled components for better layout
const CategoryMenuItem = styled(MenuItem)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1.5, 2),
    '&:hover': {
        backgroundColor: theme.palette.action.hover,
    },
    '&.Mui-selected': {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.contrastText,
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        }
    }
}));

const CategoryContent = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
}));

const IconContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(1),
    color: theme.palette.text.secondary,
}));

export const CategoryPicker = ({category, setCategory}) => {

    const category_types = [
        {label:"Social", icon:<SportsBar />, value:'social'},
        {label:"Wellness", icon:<Spa />, value:'wellness'},
        {label:"Entertainment", icon:<Movie />, value:'entertainment'},
        {label:"Fashion", icon:<Checkroom />, value:'fashion'},
        {label:"Spirituality", icon:<Flare />, value:'spirituality'},
        {label:"Sports & Fitness", icon:<Sports />, value:'sport_fitness'},
        {label:"Travel", icon:<TravelExplore />, value:'travel'},
        {label:"Food & Dining", icon:<Restaurant />, value:'food_dining'},
        {label:"Arts & Culture", icon:<Palette />, value:'arts_culture'},
        {label:"Technology", icon:<Computer />, value:'technology'},
        {label:"Business & Networking", icon:<Business />, value:'business_networking'},
        {label:"Education & Learning", icon:<School />, value:'education_learning'},
        {label:"Music", icon:<MusicNote />, value:'music'},
        {label:"Outdoor & Recreation", icon:<Nature />, value:'outdoor_recreation'},
        {label:"Gaming", icon:<SportsEsports />, value:'gaming'},
        {label:"Photography", icon:<CameraAlt />, value:'photography'},
        {label:"Volunteer & Community", icon:<VolunteerActivism />, value:'volunteer_community'},
        {label:"Health & Fitness", icon:<FitnessCenter />, value:'health_fitness'},
        {label:"Books & Literature", icon:<MenuBook />, value:'books_literature'},
        {label:"LGBTQ+", icon:<Favorite />, value:'lgbtq'},
        {label:"Relationships & Dating", icon:<DateRange />, value:'relationships_dating'},
        {label:"Career & Professional", icon:<Work />, value:'career_professional'},
        {label:"Hobbies & Crafts", icon:<BuildCircle />, value:'hobbies_crafts'},
        {label:"Other", icon:<AllInclusive />, value:'other'},
    ];

    const handleCategoryChange = (event) => {
        setCategory(event.target.value);
    };

    const getSelectedCategoryLabel = () => {
        const selectedCategory = category_types.find(cat => cat.value === category);
        return selectedCategory ? selectedCategory.label : '';
    };

    return (
        <FormControl fullWidth variant="outlined">
            <InputLabel id="category-select-label">Categories</InputLabel>
            <Select
                labelId="category-select-label"
                id="category-select"
                value={category || ''}
                label="Categories"
                onChange={handleCategoryChange}
                displayEmpty
                renderValue={(selected) => {
                    if (!selected) {
                        return <Typography color="text.secondary">Select a category</Typography>;
                    }
                    const selectedCategory = category_types.find(cat => cat.value === selected);
                    return (
                        <CategoryContent>
                            <Typography>{selectedCategory?.label}</Typography>
                            <IconContainer>
                                {selectedCategory?.icon}
                            </IconContainer>
                        </CategoryContent>
                    );
                }}
            >
                {category_types.map((categoryItem, index) => (
                    <CategoryMenuItem key={index} value={categoryItem.value}>
                        <CategoryContent>
                            <Typography variant="body1">
                                {categoryItem.label}
                            </Typography>
                            <IconContainer>
                                {categoryItem.icon}
                            </IconContainer>
                        </CategoryContent>
                    </CategoryMenuItem>
                ))}
            </Select>
        </FormControl>
    );
}